import { Check } from "lucide-react";

/**
 * What a service can cover.
 *
 * A two-column tick list on a wide screen, one on a phone, with the optional
 * `aside` card carrying the short caveat about scope rather than burying it in
 * a paragraph.
 */
export const CheckList = ({ heading, lead, items, note, asideTitle, slug }) => (
  <section data-testid={`${slug}-checklist`} className="py-14 sm:py-20">
    <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
        <div className="lg:col-span-7">
          <h2 className="max-w-[32ch] text-[27px] font-bold leading-[1.15] tracking-[-0.015em] text-foreground sm:text-[34px]">
            {heading}
          </h2>
          {lead ? (
            <p className="mt-4 max-w-[60ch] text-[15px] leading-relaxed text-muted-foreground sm:text-base">
              {lead}
            </p>
          ) : null}

          <ul className="mt-8 grid grid-cols-1 gap-x-8 gap-y-3 sm:grid-cols-2">
            {items.map((item) => (
              <li key={item} className="flex items-start gap-2.5 text-[14.5px] text-foreground">
                <Check
                  className="mt-[3px] h-4 w-4 shrink-0 text-[color:var(--tt-accent)]"
                  aria-hidden="true"
                />
                <span className="leading-relaxed">{item}</span>
              </li>
            ))}
          </ul>
        </div>

        {note ? (
          <aside className="lg:col-span-5">
            <div className="tt-card border-l-[3px] border-l-[color:var(--tt-accent)] p-6">
              <h3 className="tt-eyebrow">{asideTitle || "Worth knowing"}</h3>
              <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{note}</p>
            </div>
          </aside>
        ) : null}
      </div>
    </div>
  </section>
);
